import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c8c10d4")

_pushScopeId("data-v-9c8c10d4")
const _hoisted_1 = { class: "image-choose-container" }
const _hoisted_2 = { class: "height100per overflow-hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_enlarge_image = _resolveComponent("enlarge-image")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("img", {
      class: "cursor-pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.choose && _ctx.choose(...args))),
      src: require('@/assets/image/add-image.png')
    }, null, 8, ["src"]), [
      [_vShow, _ctx.isFile == false]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("img", {
        ref: "chooseImg",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowLarge = true))
      }, null, 512),
      _createVNode("img", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
        ref: "deleteBtn",
        class: "image-choose-delete-btn",
        src: require('@/assets/image/delete-bottom.png')
      }, null, 8, ["src"])
    ], 512), [
      [_vShow, _ctx.isFile == true]
    ]),
    _createVNode("input", {
      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
      class: "display-none",
      accept: _ctx.accept,
      type: "file",
      ref: "fileInput"
    }, null, 40, ["accept"]),
    _withDirectives(_createVNode(_component_enlarge_image, {
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowLarge = false)),
      picAddress: _ctx.fileUrl
    }, null, 8, ["picAddress"]), [
      [_vShow, _ctx.isShowLarge]
    ])
  ]))
})